import Quill from '../core/quill';
import ArticleTheme from './article';
import AsideContainer, {getAsideContainerValue} from '../blots/asideContainer';
import Delta from "quill-delta";
import extend from "extend";

const CLIPBOARD_CONFIG = [
  ['div', function (node) {
    if (node.classList.contains('with-aside')) {
      const value = getAsideContainerValue(node);
      return new Delta().insert({asideContainer: value});
    }
    if (node.classList.contains('gallery')) {
      const images = node.querySelectorAll('img');
      return new Delta().insert({gallery: images});
    }
    if (node.dataset && node.dataset.excursions) {
      const excursions = JSON.parse(node.dataset.excursions);
      return new Delta().insert({excursions: excursions});
    }
    return new Delta();
  }],
];

class IcelandArticleTheme extends ArticleTheme {
  constructor(quill, options) {
    super(quill, options);
    
    Quill.register({
      'blots/asideContainer': AsideContainer,
    });
    
    quill.container.classList.add('ql-iceland');
    quill.root.classList.add('entry-content');
  }
  
  extendToolbar(toolbar) {
    super.extendToolbar(toolbar);
    
    CLIPBOARD_CONFIG.forEach(
      ([selector, matcher]) => {
        this.quill.clipboard.addMatcher(selector, matcher);
      },
    );
  }
}

IcelandArticleTheme.DEFAULTS = extend(true, {}, ArticleTheme.DEFAULTS, {
  modules: {
    embedButtons: ['img', 'gallery', 'embed', 'toc', 'excursions', 'aside', 'divider']
  }
});

export default IcelandArticleTheme;
